import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { AbTestHashResponse } from '@doda/api-client/aspida/@types';
import { getAccessToken } from '@doda/common/src/services/getAccessToken';
import { appAxios } from '../libs/axios/appAxios';

const ORIGINL_GROUP_NO = 1;

export const getGroupNoWithBearerAuth = async (projectId: string) => {
  try {
    const accessToken = await getAccessToken();

    if (!accessToken) {
      window.DD_LOGS?.logger.error(
        'ABテスト基盤グループNo取得時：アクセストークン取得失敗'
      );
    }

    const headers: IncomingHttpHeaders = {
      Authorization: `Bearer ${accessToken}`, // Authorizationヘッダーを設定
    };

    const response: AxiosResponse<AbTestHashResponse> = await appAxios({
      url: `/api/v1/abtests/authenticated/${projectId}`,
      headers,
    });

    return response.data.groupNo !== undefined
      ? response.data.groupNo
      : ORIGINL_GROUP_NO;
  } catch (error) {
    window.DD_LOGS?.logger.error(
      `ABテスト基盤グループNo取得時にエラーが発生しました。error: ${error}`
    );
    return ORIGINL_GROUP_NO;
  }
};
